import React, { Component } from 'react';
import {
    Grid, Row, Col,
    Media,
    FormControl, FormGroup
} from 'react-bootstrap';
import queryString from 'query-string';

import Card from 'components/Card/Card.jsx';

import Button from 'elements/CustomButton/CustomButton.jsx';
import logo from "logo.png";
import { Authenticator } from 'services/AuthService.jsx'
import { Redirect } from 'react-router-dom'
import NotificationSystem from 'react-notification-system';
import { style } from "variables/Variables.jsx";
import { PROD } from "services/ConfigService.jsx"

class RegisterPage extends Component{
    state = {
      redirectToHome: Authenticator.authenticated,
      _notificationSystem: null,
      email: "",
      password: "",
      password_repeat: "",
      name: "",
      company: "",
      inviteId: null
    }
    constructor(props) {
        super(props);
        this.handleNotification = this.handleNotification.bind(this);
    }
    componentDidMount() {
      let params = queryString.parse(this.props.location.search);
      let mail = params['mail'];
      var newState = this.state;
      newState['_notificationSystem'] = this.refs.notificationSystem;
      if (mail) {
        newState['email'] = mail;
      }
      if (params['inviteId']) {
        newState['inviteId'] = params['inviteId'];
      }
      this.setState(newState);

    }
    handleNotification(message) {
      var level = 'warning';
      this.state._notificationSystem.addNotification({
          title: (<span data-notify="icon" className="pe-7s-attention"></span>),
          message: (
              <div>
                  {message}
              </div>
          ),
          level: level,
          position: 'tc',
          autoDismiss: 3,
          dismissible: false
      });
    }
    handleChange(e) {
      this.setState({[e.target.name]: e.target.value});
    }
    register(e) {
      e.preventDefault();
      Authenticator.register({
        email: this.state.email,
        password: this.state.password,
        passwordRepeat: this.state.password_repeat,
        name: this.state.name,
        company: this.state.company
      }, (response) => {
        if (response.success) {
          window.gtag_report_conversion();
          this.setState(() => ({
            redirectToHome: true
          }));
        } else {
          response.errors.forEach((element) => {
            this.handleNotification(element);
          });
        }
      });
    }
    render() {
      console.warn("test");
      console.warn(this.state);
      const redirectToHome = this.state.redirectToHome;
      if (redirectToHome === true) {
        return (<Redirect to={'/'} />);
      } else {
        return (
            <Grid>
              <NotificationSystem ref="notificationSystem" style={style}/>
                <Row>
                    <Col md={8} mdOffset={2}>
                        <div className="header-text register-page">
                          <div className="logo-img">
                              <img src={logo} alt="react-logo" />
                          </div>
                            <h2>DataGekko</h2>
                            <h4>Register for free and experience DataGekko today</h4>
                            <hr />
                        </div>
                    </Col>
                    { (PROD && (false || this.state.inviteId == "8e791765-9dd9-42e2-802d-6a4425a7b905")) &&
                    <Col md={4} mdOffset={2}>
                        <Media>
                            <Media.Left>
                                <div className="icon">
                                    <i className="pe-7s-user"></i>
                                </div>
                            </Media.Left>
                            <Media.Body>
                                <Media.Heading>
                                    Free Account
                                </Media.Heading>
                                Your account is free and you get a free playround project to get started.
                            </Media.Body>
                        </Media>
                        <Media>
                            <Media.Left>
                                <div className="icon">
                                    <i className="pe-7s-graph1"></i>
                                </div>
                            </Media.Left>
                            <Media.Body>
                                <Media.Heading>
                                    Data Exploration
                                </Media.Heading>
                                Send data via MQTT and start exploring it in real time.
                            </Media.Body>
                        </Media>
                        <Media>
                            <Media.Left>
                                <div className="icon">
                                    <i className="pe-7s-headphones"></i>
                                </div>
                            </Media.Left>
                            <Media.Body>
                                <Media.Heading>
                                    Support
                                </Media.Heading>
                                If you need extra help send us an email or reach out via the chat bubble.
                            </Media.Body>
                        </Media>
                    </Col>
                    }
                    { (PROD && (false || this.state.inviteId == "8e791765-9dd9-42e2-802d-6a4425a7b905")) &&
                        <Col md={4}>
                            <form onSubmit={this.register.bind(this)}>
                                <Card
                                    plain
                                    content={
                                        <div>
                                            <FormGroup>
                                                <FormControl
                                                    type="text"
                                                    name="name"
                                                    placeholder="Your Name"
                                                    onChange={this.handleChange.bind(this)}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <FormControl
                                                    type="text"
                                                    name="company"
                                                    placeholder="Company"
                                                    onChange={this.handleChange.bind(this)}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <FormControl
                                                    type="email"
                                                    name="email"
                                                    placeholder="Enter Email"
                                                    value={this.state.email}
                                                    onChange={this.handleChange.bind(this)}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <FormControl
                                                    type="password"
                                                    name="password"
                                                    placeholder="Password"
                                                    onChange={this.handleChange.bind(this)}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <FormControl
                                                    type="password"
                                                    name="password_repeat"
                                                    placeholder="Password Confirmation"
                                                    onChange={this.handleChange.bind(this)}
                                                />
                                            </FormGroup>
                                        </div>
                                    }
                                    ftTextCenter
                                    legend={
                                        <Button type="submit" wd fill neutral>
                                            Create Free Account
                                        </Button>
                                    }
                                />
                            </form>
                        </Col>
                    }
                    { (!PROD || true) && (this.state.inviteId != "8e791765-9dd9-42e2-802d-6a4425a7b905") &&
                        <Col md={8} mdOffset={2}>
                            <div className="header-text register-page">
                                <h4>Sorry, we are currently closed for new registrations, sign up for our mailing list to receive a notification when we have an open spot for you.</h4>
                                <hr />
                            </div>
                        </Col>
                    }
                </Row>
            </Grid>
        );
      }
    }
}

export default RegisterPage;



// WEBPACK FOOTER //
// ./src/views/Pages/RegisterPage.jsx